import i18next from 'i18next';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_SAVE_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';

import QuickCreateIngredientForm from '../components/QuickCreateIngredientForm';

const MODAL_WIDTH = '560px';

export const getQuickCreateIngredientModalConfig = ({
  ingredient,
  setIngredient,
  ingredientsCategories,
  availableAllergens,
  isLoading,
  isSaving,
  handleSave,
  handleCloseCleanUp,
}) => {
  const isSaveDisabled = !ingredient.name.trim() || !ingredient.unit || isLoading || isSaving;

  return {
    type: 'action',
    width: MODAL_WIDTH,
    height: 'auto',
    icon: '/images/inpulse/add-black-small.svg',
    title: i18next.t('ADMIN.INGREDIENTS.CREATE'),
    applyOverflow: false,
    isLoading,
    handleCloseCleanUp,
    component: QuickCreateIngredientForm,
    data: {
      ingredient,
      setIngredient,
      ingredientsCategories,
      availableAllergens,
    },
    actions: [
      {
        ...GENERIC_MODAL_CANCEL_BUTTON(),
        isDisabled: isSaving,
      },
      {
        ...GENERIC_MODAL_SAVE_BUTTON(),
        isDisabled: isSaveDisabled,
        preventClosing: true,
        handleClick: handleSave,
      },
    ],
  };
};
